<template>
  <div>
    <div class="title">
      Pays
      <span
        class="conti clickable"
        @click="goToCurrentContinent()"
      >> {{getCurrentContinent.name}}</span>
    </div>
    <simplebar class="articlesContainer simple" data-simplebar-auto-hide="false">
      <div
        :key="c.conti"
        v-for="c in getCountries"
        class="cardCountry md-layout clickable"
        @click="navigateToCountry(c)"
      >
        <div
          class="countryCardHeader md-layout-item md-size-100"
          :style="{ 'background-image' : getUrl(c) }"
        ></div>
        <div class="contentName md-layout-item md-size-100">{{c.name}}</div>
      </div>
    </simplebar>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import simplebar from "simplebar-vue";
export default {
  data() {
    return {
      center: [47.41322, -1.219482],
      zoom: 4,
      src: null,
      options: {
        zoomControl: false,
        scrollWheelZoom: false,
        dragging: false
      },
      url:
        "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png"
    };
  },
  computed: {
    ...mapGetters(["getCountries", "getCurrentContinent", "getFlagMap"])
  },
  methods: {
    ...mapActions(["setCurrentCountry"]),
    navigateToCountry(c) {
      this.setCurrentCountry(c);
      this.$router.push("articles");
    },
    getUrl(c) {
      return `url('${this.getFlagMap[c.country]}')`;
    },
    goToCurrentContinent() {
      this.$router.push("/map");
    }
  },
  components: {
    simplebar
  }
};
</script>
<style>
.md-app-content {
  padding: 0 !important;
}

.title {
  font-size: 28px;
  text-align: left;
  padding: 20px;
}

.cardCountry {
  background-position: left;
  background-repeat: no-repeat;
  background-size: contain;
  margin: 10px;
  width: 300px;
  border-radius: 7px 7px 0 0;
  background-color: #046380 !important;
  color: #efecca !important;
}

.countryCardHeader {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 70px;
  border-radius: 7px 7px 0 0;
}
.contentName {
  font-size: 20px;
  padding: 20px;
}

.conti {
  font-size: 13px;
}

@media only screen and (max-width: 959px) {
  #mapid {
    z-index: 0;
    height: 40vh !important;
  }

  .cardCountry {
    width: 80%;
    margin-left: 10%;
    margin-right: 10%;
  }
}
</style>